import { forwardRef, memo, MouseEventHandler, ReactNode, useEffect, useState } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import classNames from 'classnames';
import { PUBLIC_URL } from '../../../config';
import {
    UserHintAvatarStyled,
    UserHintButtonStyled,
    UserHintStyled,
    UserHintWrapperStyled,
} from './styled/UserHintStyled';

interface IUserHintProps {
    avatarPosition?: 'top' | 'bottom';
    buttonText?: string;
    children: ReactNode;
    onButtonClick: MouseEventHandler<HTMLDivElement>;
}

const UserHint = forwardRef<HTMLDivElement, IUserHintProps>((props, ref) => {
    const { getLangPath } = useLangContext();
    const {
        children,
        buttonText = getLangPath('buy_sell_hint.got_it'),
        onButtonClick,
        avatarPosition = 'bottom',
    } = props;
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        setIsInitialized(true);
    }, []);

    return <UserHintWrapperStyled ref={ref} className={classNames({
        isInitialized,
        'avatar-top': avatarPosition === 'top',
        'avatar-bottom': avatarPosition === 'bottom',
    })}
                                  onClick={e => e.stopPropagation()}>
        <UserHintStyled>
            {children}
            <UserHintButtonStyled onClick={onButtonClick}>
                {buttonText}
            </UserHintButtonStyled>
        </UserHintStyled>
        <UserHintAvatarStyled url={`${PUBLIC_URL}/assets/tutorials/avatar-guru.png`}/>
    </UserHintWrapperStyled>;
});

export default memo(UserHint);
